import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "browse-designs-page" }
const _hoisted_2 = { class: "page-container" }
const _hoisted_3 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_4 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_5 = { class: "filter-bar" }
const _hoisted_6 = { class: "filter-bar-inner" }
const _hoisted_7 = { class: "filter-group" }
const _hoisted_8 = { class: "filter-label" }
const _hoisted_9 = { class: "filter-pills" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "filter-group" }
const _hoisted_12 = { class: "filter-label" }
const _hoisted_13 = { class: "filter-pills" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "filter-group" }
const _hoisted_16 = { class: "filter-label" }
const _hoisted_17 = { class: "filter-pills" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "filter-group filter-group--size" }
const _hoisted_20 = { class: "filter-label" }
const _hoisted_21 = { class: "filter-pills" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "filter-meta" }
const _hoisted_24 = { class: "filter-count" }
const _hoisted_25 = { class: "image-mode-toggle" }
const _hoisted_26 = { class: "mode-toggle-outside" }
const _hoisted_27 = { class: "mode-toggle-inner" }
const _hoisted_28 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_29 = {
  key: 1,
  class: "designs-grid"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "card-image-wrapper" }
const _hoisted_32 = ["src", "alt"]
const _hoisted_33 = { class: "card-content" }
const _hoisted_34 = { class: "card-header" }
const _hoisted_35 = { class: "card-title" }
const _hoisted_36 = {
  key: 0,
  class: "card-price"
}
const _hoisted_37 = { class: "card-description" }
const _hoisted_38 = { class: "card-stats" }
const _hoisted_39 = {
  key: 0,
  class: "stat-item"
}
const _hoisted_40 = {
  key: 1,
  class: "stat-item"
}
const _hoisted_41 = {
  key: 2,
  class: "stat-item"
}
const _hoisted_42 = {
  key: 3,
  class: "stat-item"
}
const _hoisted_43 = ["onClick"]
const _hoisted_44 = {
  key: 3,
  class: "location-cta"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$setup.isEmbedded)
      ? (_openBlock(), _createBlock($setup["CustomerNavbar"], {
          key: 0,
          logoUrl: $setup.projectPageData?.residentialContent?.logoImageUrl,
          brandText: $setup.projectPageData?.residentialContent?.brandText || $setup.estateName,
          showMap: !!$setup.estateId,
          onBack: $setup.goBack,
          onMapClick: $setup.openMap
        }, null, 8, ["logoUrl", "brandText", "showMap"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _cache[22] || (_cache[22] = _createElementVNode("header", { class: "page-header" }, [
        _createElementVNode("h1", { class: "page-title" }, "Find Your Perfect Home"),
        _createElementVNode("p", { class: "page-subtitle" }, "Explore modern, accessible home designs built for comfort, ease, and everyday enjoyment.")
      ], -1)),
      ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("div", { class: "spinner" }, null, -1),
            _createElementVNode("p", null, "Loading home designs...", -1)
          ]))]))
        : ($setup.houseDesigns.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("p", null, "No home designs available for this community at the moment.", -1)
            ]))]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, [
                      _createVNode($setup["Bed"], { size: 14 }),
                      _cache[8] || (_cache[8] = _createTextVNode("Beds", -1))
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["filter-pill", { active: $setup.filterBedrooms === null }]),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.filterBedrooms = null))
                      }, "Any", 2),
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([2, 3, 4], (n) => {
                        return _createElementVNode("button", {
                          class: _normalizeClass(["filter-pill", { active: $setup.filterBedrooms === n }]),
                          key: n,
                          onClick: ($event: any) => ($setup.filterBedrooms = n)
                        }, _toDisplayString(n) + "+", 11, _hoisted_10)
                      }), 64))
                    ])
                  ]),
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "filter-divider" }, null, -1)),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, [
                      _createVNode($setup["Bath"], { size: 14 }),
                      _cache[9] || (_cache[9] = _createTextVNode("Baths", -1))
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["filter-pill", { active: $setup.filterBathrooms === null }]),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.filterBathrooms = null))
                      }, "Any", 2),
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3], (n) => {
                        return _createElementVNode("button", {
                          class: _normalizeClass(["filter-pill", { active: $setup.filterBathrooms === n }]),
                          key: n,
                          onClick: ($event: any) => ($setup.filterBathrooms = n)
                        }, _toDisplayString(n) + "+", 11, _hoisted_14)
                      }), 64))
                    ])
                  ]),
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "filter-divider" }, null, -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, [
                      _createVNode($setup["Car"], { size: 14 }),
                      _cache[10] || (_cache[10] = _createTextVNode("Cars", -1))
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["filter-pill", { active: $setup.filterGarage === null }]),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.filterGarage = null))
                      }, "Any", 2),
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2], (n) => {
                        return _createElementVNode("button", {
                          class: _normalizeClass(["filter-pill", { active: $setup.filterGarage === n }]),
                          key: n,
                          onClick: ($event: any) => ($setup.filterGarage = n)
                        }, _toDisplayString(n) + "+", 11, _hoisted_18)
                      }), 64))
                    ])
                  ]),
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "filter-divider" }, null, -1)),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, [
                      _createVNode($setup["Maximize2"], { size: 14 }),
                      _cache[11] || (_cache[11] = _createTextVNode("Size", -1))
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["filter-pill", { active: $setup.filterSizeBucket === null }]),
                        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.filterSizeBucket = null))
                      }, "Any", 2),
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.SIZE_BUCKETS, (bucket) => {
                        return _createElementVNode("button", {
                          class: _normalizeClass(["filter-pill", { active: $setup.filterSizeBucket === bucket.key }]),
                          key: bucket.key,
                          onClick: ($event: any) => ($setup.filterSizeBucket = bucket.key)
                        }, _toDisplayString(bucket.label), 11, _hoisted_22)
                      }), 64))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("span", _hoisted_24, _toDisplayString($setup.filteredDesigns.length === $setup.houseDesigns.length ? `Showing all ${$setup.houseDesigns.length} homes` : `Showing ${$setup.filteredDesigns.length} of ${$setup.houseDesigns.length} homes`), 1),
                    ($setup.hasActiveFilters)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "filter-clear",
                          onClick: $setup.clearFilters
                        }, [
                          _createVNode($setup["X"], { size: 13 }),
                          _cache[12] || (_cache[12] = _createTextVNode("Clear all", -1))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["mode-btn", { active: $setup.imageMode === 'exterior' }]),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.imageMode = 'exterior'))
                    }, [
                      _createVNode($setup["Home"], { size: 16 }),
                      _cache[16] || (_cache[16] = _createElementVNode("span", null, "Home Exterior", -1))
                    ], 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["mode-btn", { active: $setup.imageMode === 'floorplan' }]),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.imageMode = 'floorplan'))
                    }, [
                      _createVNode($setup["LayoutTemplate"], { size: 16 }),
                      _cache[17] || (_cache[17] = _createElementVNode("span", null, "Floor Plan", -1))
                    ], 2)
                  ])
                ])
              ]),
              ($setup.filteredDesigns.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [...(_cache[18] || (_cache[18] = [
                    _createElementVNode("p", null, "No home designs match your current filters.", -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredDesigns, (design) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "design-card",
                        key: design._id,
                        onClick: ($event: any) => ($setup.viewHouse(design._id))
                      }, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("img", {
                            class: _normalizeClass(["card-image", { 'card-image--floorplan': $setup.imageMode === 'floorplan' }]),
                            src: $setup.imageMode === 'exterior' ? design.mainImages?.[0] || '/placeholder-house.jpg' : design.floorplans?.[0]?.url || design.mainImages?.[0] || '/placeholder-house.jpg',
                            alt: design.name
                          }, null, 10, _hoisted_32)
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("h3", _hoisted_35, _toDisplayString(design.name), 1),
                            (design.basePrice)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_36, "From " + _toDisplayString($setup.formatPrice(design.basePrice)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("p", _hoisted_37, _toDisplayString($setup.truncateDescription(design.description)), 1),
                          _createElementVNode("div", _hoisted_38, [
                            (design.bedroom)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                  _createVNode($setup["Bed"], {
                                    class: "stat-icon",
                                    size: 16
                                  }),
                                  _createElementVNode("span", null, _toDisplayString(design.bedroom), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (design.bathroom)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                  _createVNode($setup["Bath"], {
                                    class: "stat-icon",
                                    size: 16
                                  }),
                                  _createElementVNode("span", null, _toDisplayString(design.bathroom.quantity || design.bathroom), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (design.garage)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                  _createVNode($setup["Car"], {
                                    class: "stat-icon",
                                    size: 16
                                  }),
                                  _createElementVNode("span", null, _toDisplayString(design.garage), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (design.area)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                  _createVNode($setup["Maximize2"], {
                                    class: "stat-icon",
                                    size: 16
                                  }),
                                  _createElementVNode("span", null, _toDisplayString($setup.formatArea(design.area)), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("button", {
                            class: "view-btn",
                            onClick: _withModifiers(($event: any) => ($setup.viewHouse(design._id)), ["stop"])
                          }, "View Home", 8, _hoisted_43)
                        ])
                      ], 8, _hoisted_30))
                    }), 128))
                  ]))
            ], 64)),
      (!$setup.loading && $setup.houseDesigns.length > 0)
        ? (_openBlock(), _createElementBlock("section", _hoisted_44, [
            _cache[20] || (_cache[20] = _createElementVNode("h2", { class: "cta-title" }, "Prefer to Start with Location?", -1)),
            _cache[21] || (_cache[21] = _createElementVNode("p", { class: "cta-description" }, "Browse available lots on the interactive estate map and find the perfect position for your new home.", -1)),
            _createElementVNode("button", {
              class: "cta-btn",
              onClick: $setup.openMap
            }, [...(_cache[19] || (_cache[19] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "18",
                height: "18",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "white",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("polygon", { points: "1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" }),
                _createElementVNode("line", {
                  x1: "8",
                  y1: "2",
                  x2: "8",
                  y2: "18"
                }),
                _createElementVNode("line", {
                  x1: "16",
                  y1: "6",
                  x2: "16",
                  y2: "22"
                })
              ], -1),
              _createElementVNode("span", null, "Explore the Map", -1)
            ]))])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode($setup["CustomerBottomNavigation"], {
      currentView: "browse",
      onNavigate: $setup.handleBottomNavigate
    })
  ]))
}